import axios from 'axios';
import authToken from 'js/library/utils/API/authToken';
import cfac22 from '../cfac22';

export default function updateCard(uId, cardId, body) {
  return new Promise((resolve, reject) => {
    authToken(uId)
      .then((token) => {
        axios
          .put(
            `${cfac22('API_HOST_V2')}/cards/${cardId}`,
            {
              ...body,
            },
            { headers: { authorization: `Bearer ${token}`, 'Full-Url': window.location.href } }
          )
          .then((result) => {
            // console.log("RESULT_UPDATE_CARD: ", result);
            resolve(result.data);
          })
          .catch((error) => {
            //console.log("ERROR_UPDATE_CARD: ", error);
            return reject(error);
          });
      })
      .catch((error) => {
        //console.log("ERROR_TOKEN:", error);
        reject(error);
      });
  });
}
